// extracted by mini-css-extract-plugin
export default {"heading":"Cw-z","corrected":"Dw-z","redirectVerbiageContainer":"Ew-z","redirectVerbiageText":"Fw-z"};